import { Pipe, PipeTransform } from '@angular/core';

import startsWith from 'lodash-es/startsWith';

const httpPrefix = 'http://';
const httpsPrefix = 'https://';

@Pipe({
  name: 'appLinkify',
})
export class LinkifyPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return value;
    }

    if (startsWith(value, httpPrefix) || startsWith(value, httpsPrefix)) {
      return value;
    }
    return `${httpPrefix}${value}`;
  }
}
